import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { IMAGES } from '../data/landing';
import { useOfferCountdown } from '../utils/useOfferCountdown';
export function Hero() {
  const countdown = useOfferCountdown();
  return <section className="relative w-full overflow-hidden bg-[#0d1f36] pt-9 text-white sm:pt-10" data-id="element-131" data-mp="4mrul1r1q1lr">
      <div className="fixed inset-x-0 top-0 z-[60] flex min-h-9 items-center justify-center bg-red-600 px-3 py-1.5 text-center text-[10px] font-bold uppercase tracking-wide text-white shadow-md sm:min-h-10 sm:text-sm" data-id="element-132" data-mp="129qs1epkbdkp">
        <span className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5" data-id="element-133" data-mp="s9q7jpfyirex">
          <span data-id="element-134" data-mp="nbexpepnwgwp">🔥 Oferta 63% OFF termina en</span>
          <span aria-live="polite" className="rounded bg-[#0d1f36] px-2 py-0.5 font-black tabular-nums text-yellow-300" data-id="element-135" data-mp="3d1ikl9ryvcnf">
            {countdown}
          </span>
        </span>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.55
    }} className="mx-auto max-w-5xl px-4 pb-3 pt-8 text-center sm:px-6 sm:pt-12" data-id="element-136" data-mp="384s62qvt8p44">
        <div className="mb-4 flex flex-wrap items-center justify-center gap-2" data-id="element-137" data-mp="39aupza1hhgvn">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow-400 px-3 py-1 text-xs font-black uppercase text-[#0d1f36]" data-id="element-138" data-mp="3e9fpt8ctpyjk">
            <FlameIcon className="h-3.5 w-3.5" data-id="element-139" data-mp="30h9blrt8e1mr" /> Air Fryer Argentina
          </span>
        </div>
        <h1 className="text-3xl font-black leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-140" data-mp="359sxrd5zi536">
          Dejá de tirar <span className="text-red-400" data-id="element-141" data-mp="2qleq8oxmhsga">$15.000 por noche</span> en delivery frío. Aprendé el secreto para comer como en un{' '}
          <span className="text-yellow-400" data-id="element-142" data-mp="2vglkz78wzmt2">BODEGÓN</span> en 15 min y por menos de lo que sale un alfajor.
        </h1>
        <p className="mx-auto mt-5 max-w-3xl text-base leading-relaxed text-slate-200 sm:text-lg" data-id="element-143" data-mp="2lkike5tpnw88">
          El sistema definitivo de <span className="font-bold text-white" data-id="element-144" data-mp="s335tfryasyl">250 recetas</span> diseñado para el bolsillo argentino. Dominá tu Air Fryer, ahorrá el{' '}
          <span className="font-bold text-yellow-300" data-id="element-145" data-mp="n98d5mudb3nd">50% en el súper</span> y olvidate de lavar ollas para siempre.
        </p>
      </motion.div>

      <div className="mx-auto grid max-w-6xl items-center gap-7 px-4 pb-9 pt-4 sm:px-6 lg:grid-cols-[1.08fr_.92fr] lg:gap-10 lg:pb-12" data-id="element-146" data-mp="ddne9xklijhu">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.08
      }} className="order-1" data-id="element-147" data-mp="1b0du65c1o1z9">
          <img src={IMAGES.mockupPrincipal} alt="MegaPack Air Fryer Argentina: 4 tomos de recetas y 5 bonos" fetchPriority="high" decoding="async" className="mx-auto w-full max-w-xl drop-shadow-2xl" data-id="element-148" data-mp="114ki0n28mai0" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.16
      }} className="order-2 rounded-3xl border border-white/10 bg-white/5 p-5 shadow-2xl sm:p-7" data-id="element-149" data-mp="3hrlk4hb3w58g">
          <CtaButton large data-id="element-150" data-mp="218k0693f759p" />
          <div className="mt-5 flex items-center justify-center gap-2 rounded-xl border border-yellow-400/30 bg-[#102946] px-4 py-3 text-center text-sm font-bold text-yellow-100" data-id="element-151" data-mp="269hgsh8s7r93">
            <span className="flex items-center gap-1 text-yellow-400" aria-label="Calificación 4.9 de 5 estrellas" data-id="element-152" data-mp="2g02kuk785nze">
              <StarIcon className="h-4 w-4 fill-current" data-id="element-153" data-mp="2kydrkm283ide" /> 4.9/5
            </span>
            <span className="text-slate-400" data-id="element-154" data-mp="2p0qnyjv2y3xi">—</span>
            <span data-id="element-155" data-mp="2p10eq9ny8f49">Más de 12.400 familias argentinas cocinando hoy</span>
          </div>
        </motion.div>
      </div>

      <div className="relative w-full" data-id="element-156" data-mp="2txhc7uh1g5u0">
        <img src={IMAGES.heroFood} alt="Plato abundante estilo bodegón argentino cocinado en Air Fryer" loading="lazy" decoding="async" className="h-48 w-full object-cover sm:h-72 lg:h-80" data-id="element-157" data-mp="umzky379aib1" />
        <div className="absolute inset-0 flex items-end bg-gradient-to-t from-[#0d1f36] via-[#0d1f36]/25 to-transparent" data-id="element-158" data-mp="4auqyxhtlbqy">
          <p className="mx-auto max-w-3xl px-4 pb-5 text-center text-base font-bold text-white sm:text-xl" data-id="element-159" data-mp="3vgniivb5q1sf">
            Milanesas crocantes, pollo dorado y empanadas de bodegón… sin freidora de aceite y sin ensuciar la cocina.
          </p>
        </div>
      </div>
    </section>;
}